/**
 * App version — deliberately hand-maintained at code level, NOT sourced from
 * env or CI build args.
 *
 * Why: every other config value in v2 is injected at *runtime*
 * (`window.__CONFIG__` from `config.js`, see config.ts) so one image can run
 * any tenant, and CI pushes a *moving* image tag per release branch
 * (`stage-sandbox`, `latest`). Both of those make an env-sourced version able
 * to drift from — or outright lie about — the bundle actually running in the
 * browser. A constant compiled into the bundle cannot lie: what the UI shows
 * is exactly what was built.
 *
 * Maintenance rules:
 *   1. Bump VERSION + RELEASED in the SAME MR as the change they describe.
 *   2. Add a matching CHANGELOG.md entry with the ClickUp id.
 *   3. Tag the merge commit `v<VERSION>` — that is what recovers the exact
 *      commit from a version reported in a bug report.
 *
 * Scheme: PATCH = bugfix · MINOR = ticket/feature shipped · MAJOR = milestone.
 *
 * Keep in sync with `package.json` "version" (enforced by version.test.ts).
 */

export const VERSION = '0.10.0';

/** ISO date of the bump — makes "how old is this build?" answerable in the UI. */
export const RELEASED = '2026-10-21';

/** Display form used everywhere the version is shown to a user. */
export const VERSION_LABEL = `v${VERSION}`;
